









import { Vue, Component, Prop } from "vue-property-decorator";

import ClusterBar from "../components/ClusterBar.vue";
import { Getter } from "vuex-class";
import { ProductInstanceResult } from "@futuri/cloudsso-client";

@Component({
  components: {
    ClusterBar
  }
})
export default class AdminLayout extends Vue {
  @Getter("allInstances", { namespace: "session" })
  instances?: ProductInstanceResult[];
}
